// Sydney suburbs + key NSW regional & interstate cities for the quote autocomplete
export const suburbs = [
  // Sydney CBD & Inner City
  'Sydney CBD', 'Barangaroo', 'Darling Harbour', 'The Rocks', 'Millers Point', 'Haymarket',
  'Ultimo', 'Pyrmont', 'Chippendale', 'Surry Hills', 'Darlinghurst', 'Potts Point',
  'Elizabeth Bay', 'Rushcutters Bay', 'Woolloomooloo', 'Kings Cross', 'Redfern', 'Waterloo',
  'Zetland', 'Alexandria', 'Erskineville', 'Newtown', 'Enmore', 'Camperdown', 'Glebe',
  'Forest Lodge', 'Annandale', 'Leichhardt', 'Lilyfield', 'Rozelle', 'Balmain', 'Birchgrove',
  // Eastern Suburbs
  'Bondi', 'Bondi Beach', 'Bondi Junction', 'North Bondi', 'Bronte', 'Tamarama', 'Waverley',
  'Coogee', 'South Coogee', 'Clovelly', 'Randwick', 'Kensington', 'Kingsford', 'Maroubra',
  'Malabar', 'Little Bay', 'La Perouse', 'Matraville', 'Chifley', 'Eastgardens', 'Pagewood',
  'Botany', 'Mascot', 'Rosebery', 'Eastlakes', 'Daceyville', 'Paddington', 'Woollahra',
  'Double Bay', 'Rose Bay', 'Bellevue Hill', 'Vaucluse', 'Watsons Bay', 'Dover Heights',
  'Edgecliff', 'Point Piper', 'Darling Point', 'Queens Park', 'Centennial Park', 'Moore Park',
  // Inner West
  'Marrickville', 'Dulwich Hill', 'Petersham', 'Lewisham', 'Summer Hill', 'Ashfield',
  'Croydon', 'Croydon Park', 'Burwood', 'Strathfield', 'Homebush', 'Homebush West',
  'Concord', 'Concord West', 'Rhodes', 'Wentworth Point', 'Sydney Olympic Park', 'Five Dock',
  'Drummoyne', 'Russell Lea', 'Abbotsford', 'Wareemba', 'Chiswick', 'Canada Bay', 'Haberfield',
  'Stanmore', 'Tempe', 'Sydenham', 'St Peters', 'Earlwood', 'Canterbury', 'Campsie',
  'Belmore', 'Lakemba', 'Wiley Park', 'Punchbowl', 'Bankstown', 'Greenacre', 'Chullora',
  'Yagoona', 'Birrong', 'Regents Park', 'Berala', 'Lidcombe', 'Auburn', 'Granville',
  // South
  'Hurstville', 'Kogarah', 'Rockdale', 'Brighton-Le-Sands', 'Sans Souci', 'Ramsgate',
  'Sandringham', 'Dolls Point', 'Monterey', 'Bexley', 'Arncliffe', 'Wolli Creek', 'Turrella',
  'Banksia', 'Carlton', 'Allawah', 'Penshurst', 'Mortdale', 'Oatley', 'Riverwood', 'Peakhurst',
  'Lugarno', 'Padstow', 'Revesby', 'Panania', 'Picnic Point', 'Milperra', 'East Hills',
  'Sylvania', 'Miranda', 'Caringbah', 'Cronulla', 'Kurnell', 'Woolooware', 'Burraneer',
  'Gymea', 'Kirrawee', 'Sutherland', 'Jannali', 'Como', 'Oyster Bay', 'Engadine', 'Menai',
  // North Shore
  'North Sydney', 'Milsons Point', 'Kirribilli', 'Lavender Bay', 'McMahons Point', 'Waverton',
  'Wollstonecraft', 'Crows Nest', 'St Leonards', 'Greenwich', 'Cammeray', 'Neutral Bay',
  'Cremorne', 'Cremorne Point', 'Mosman', 'Clifton Gardens', 'Balmoral', 'Naremburn',
  'Artarmon', 'Chatswood', 'Willoughby', 'Northbridge', 'Castlecrag', 'Middle Cove',
  'Castle Cove', 'Roseville', 'Lindfield', 'Killara', 'Gordon', 'Pymble', 'Turramurra',
  'Warrawee', 'Wahroonga', 'Hornsby', 'Waitara', 'Asquith', 'Mount Colah', 'Berowra',
  'Lane Cove', 'Lane Cove North', 'Longueville', 'Riverview', 'Linley Point', 'Hunters Hill',
  'Gladesville', 'Ryde', 'North Ryde', 'East Ryde', 'West Ryde', 'Meadowbank', 'Melrose Park',
  'Putney', 'Tennyson Point', 'Eastwood', 'Denistone', 'Marsfield', 'Macquarie Park', 'Epping',
  'North Epping', 'Carlingford', 'Beecroft', 'Cheltenham', 'Pennant Hills', 'Thornleigh',
  'Normanhurst', 'West Pennant Hills', 'Cherrybrook', 'Castle Hill', 'Baulkham Hills',
  // Northern Beaches
  'Manly', 'Fairlight', 'Balgowlah', 'Balgowlah Heights', 'Clontarf', 'Seaforth', 'Manly Vale',
  'North Manly', 'Freshwater', 'Curl Curl', 'Dee Why', 'Narraweena', 'Brookvale', 'Beacon Hill',
  'Frenchs Forest', 'Forestville', 'Killarney Heights', 'Davidson', 'Belrose', 'Terrey Hills',
  'Collaroy', 'Narrabeen', 'Warriewood', 'Mona Vale', 'Newport', 'Bilgola', 'Avalon Beach',
  'Whale Beach', 'Palm Beach', 'Bayview', 'Church Point', 'Elanora Heights', 'Ingleside',
  // Western Sydney
  'Parramatta', 'North Parramatta', 'Westmead', 'Wentworthville', 'Pendle Hill', 'Toongabbie',
  'Seven Hills', 'Blacktown', 'Marayong', 'Quakers Hill', 'Schofields', 'Riverstone',
  'Rouse Hill', 'Kellyville', 'Bella Vista', 'Norwest', 'Glenwood', 'Stanhope Gardens',
  'The Ponds', 'Marsden Park', 'Box Hill', 'Doonside', 'Rooty Hill', 'Mount Druitt',
  'St Marys', 'Werrington', 'Kingswood', 'Penrith', 'Emu Plains', 'Glenmore Park',
  'Jordan Springs', 'Cranebrook', 'Cambridge Park', 'Merrylands', 'Guildford', 'Fairfield',
  'Cabramatta', 'Canley Vale', 'Canley Heights', 'Smithfield', 'Wetherill Park', 'Bossley Park',
  'Prairiewood', 'Greystanes', 'Pemulwuy', 'Girraween', 'Rydalmere', 'Ermington', 'Dundas',
  'Telopea', 'Oatlands', 'Northmead', 'Winston Hills', 'Old Toongabbie', 'Constitution Hill',
  // South West
  'Liverpool', 'Casula', 'Moorebank', 'Chipping Norton', 'Warwick Farm', 'Lurnea',
  'Prestons', 'Miller', 'Green Valley', 'Hinchinbrook', 'Hoxton Park', 'West Hoxton',
  'Middleton Grange', 'Austral', 'Leppington', 'Edmondson Park', 'Ingleburn', 'Minto',
  'Campbelltown', 'Leumeah', 'Macquarie Fields', 'Glenfield', 'Casula Mall', 'Camden',
  'Narellan', 'Mount Annan', 'Currans Hill', 'Gregory Hills', 'Oran Park', 'Harrington Park',
  // NSW Regional
  'Newcastle', 'Wollongong', 'Central Coast', 'Gosford', 'Wyong', 'Terrigal', 'Woy Woy',
  'Blue Mountains', 'Katoomba', 'Springwood', 'Richmond', 'Windsor', 'Bowral', 'Mittagong',
  'Nowra', 'Kiama', 'Shellharbour', 'Maitland', 'Cessnock', 'Port Macquarie', 'Coffs Harbour',
  'Tamworth', 'Dubbo', 'Orange', 'Bathurst', 'Wagga Wagga', 'Albury', 'Goulburn', 'Canberra',
  // Interstate
  'Melbourne', 'Brisbane', 'Gold Coast', 'Adelaide',
];
